// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V8eyt","content":"styles_content__eJsqM","tableWrap":"styles_tableWrap__2K-HJ"};